<template>
  <div>
    <v-dialog v-model="getRlImageAddDialog.show" scrollable max-width="400px">
      <v-card>
        <v-card-title class="justify-center">         
          <v-col md="6" class="justify-center">           
            <span class="headline text-center">Add Images</span>          
          </v-col>        
          <v-alert class="justify-center mb-10" :value="isMaxQuantitieImages" dense outlined >Max quantity added images is 10.</v-alert>
        </v-card-title>
        <v-card-text>    
          <v-progress-linear :active="isLoading" height="3" indeterminate absolute color="primary" />	     
          <v-col cols="12"  v-for="(image, index) in images.shownImages" :key="index" class="d-flex child-flex">
							<v-card flat tile class="d-flex">						
								<v-img :src="image" aspect-ratio="1">								
									<template v-slot:placeholder>										
										<v-row class="fill-height ma-0" align="center" justify="center">
											<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
										</v-row>
									</template>								
								</v-img>
								<v-btn class="ma-2" text icon color="grey lighten-2" @click.prevent="setDeleteAddImages(index)">
									<v-icon>close</v-icon>
								</v-btn>
							</v-card>
						</v-col>				         		        
        </v-card-text>
        <v-card-actions>
          <input ref="inputFile" @change="setImages" type="file" :rules="[...getRlDialogRules.required, ...getRlDialogRules.imageSize]" accept="image/png, image/jpeg" prepend-icon="add_a_photo" show-size counter multiple label="Image input" />
					<v-btn color="primary" :disabled="isLoading" @click="$refs.inputFile.click()" class="ma-2" value="left" >Choose File</v-btn>
          <v-spacer />
          <v-btn color="primary" :disabled="isLoading" @click.prevent="save()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import imageCompression from 'browser-image-compression';

export default {
	data() {
		return {   
      images: [],
      isMaxQuantitieImages: false,
      isLoading: false,
		}
  },   
  watch: {
    'getRlImageAddDialog.show'(newValue, OldValue) {
      if(newValue) {    
        this.isMaxQuantitieImages = false
        this.images = Object.assign([], this.getRlImageAddDialog.item.images)       
      } else {                
        this.isMaxQuantitieImages = false 
        this.images = {shownImages: [], savedImages: []}
      }
    }
  },
	methods: {
    checkQuantitieImages(e){
			let qua = e.target.files.length 
			qua += this.images.savedImages.length		
			this.isMaxQuantitieImages = (qua > 10) && true
		},
    async compressImage(image) {      
      let compressedFile     
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1000,
        useWebWorker: true
      }
      try {
        compressedFile = await imageCompression(image, options);       
      } catch (error) {
            
      }
      return compressedFile
    },   
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      })
    },

    async setImages(e) {
      this.checkQuantitieImages(e)
      if(!this.isMaxQuantitieImages){
        try{      
          this.isLoading = true;
          let oldImages = { shownImages: Object.assign([], this.images.shownImages), savedImages: Object.assign([], this.images.savedImages) }	      
          let newImages = { shownImages: [], savedImages:[] }
          let input = e.target;
          let count = input.files.length;		
          let index = 0;			
          if(input.files){
            while(count --) {         
              newImages.shownImages.push(await this.readFileAsync(input.files[index]))     
              newImages.savedImages.push(await this.compressImage(input.files[index]))         
              index++;
            }    
            this.images = Object.assign({},
            {
              shownImages: [...oldImages.shownImages, ...newImages.shownImages],
              savedImages: [...oldImages.savedImages, ...newImages.savedImages]
            })                 
          }			              
          newImages = {}
          this.clearInput()					
        }catch{
          this.isLoading = false;
        }
        this.isLoading = false
      }
		},
    clearInput() {
			this.$refs.inputFile.value=null;
		},
    setDeleteAddImages(index) {    
      let copyImages = Object.assign({},this.images)     
      copyImages.shownImages.splice(index, 1)      
      this.$set(this.images, 0, copyImages.shownImages )      
      this.images.savedImages.splice(index, 1);   
      this.isMaxQuantitieImages = false;     
    },
    save() {
      this.clearInput()    
      this.getRlImageAddDialog.item.images = this.images
      this.images = []
		  this.setRlImageAddDialog({ show: false })			
    },
    close() {
      this.isMaxQuantitieImages = false
      this.setRlImageAddDialog({ show: false })
    },
		...mapActions([
			'setRlImageAddDialog'
    ])
  },
	computed: {
    ...mapGetters([
      'getRlDialogRules',
      'getRlImageAddDialog',
      'getRlAddDialogList',
      'getRlDialogRules'
		])
  }
}
</script>

<style scoped>
	input[type="file"] {
		display: none;		
	}	
</style>